export const sanitizeHttpLink = httpLink => {
  if (httpLink == null || httpLink === '') {
    return '';
  }
  if (httpLink.startsWith('http://') || httpLink.startsWith('https://')) {
    return httpLink;
  }
  return 'http://' + httpLink;
};
